/**
 * THE DEMO ATTENDEE: a registrant made from the event's own options, for the
 * time machine's ?as=attendee. Never a real person: the microsite once
 * defaulted to a real woman's record and showed a stranger her name, email
 * and what she paid. This has none of that to show.
 */
import type { ChoicesState, EventDetailsResponse } from '@/lib/types';

export function demoChoices(details: EventDetailsResponse): ChoicesState {
  const page = details.page;
  const picks: Record<number, number> = {};
  const answers: Record<number, string> = {};
  // A different topic in each session, as a real attendee has to choose.
  const taken = new Set<string>();
  for (const row of page?.agenda ?? []) {
    if (row.optionGroupId) {
      const options = page?.topics.filter((t) => t.groupId === row.optionGroupId) ?? [];
      const pick = options.find((t) => !taken.has(t.title)) ?? options[0];
      if (pick) {
        picks[row.optionGroupId] = pick.id;
        taken.add(pick.title);
      }
    }
    if (row.question?.choices[0]) answers[row.question.formFieldId] = row.question.choices[0];
  }
  return {
    closesAt: page?.choicesCloseAt ?? null,
    locked: false,
    people: [
      {
        eventParticipantId: -1,
        contactId: -1,
        firstName: 'Avery',
        lastName: 'Sample',
        canChange: true,
        picks,
        answers,
      },
    ],
  };
}
